import { TDashboardConfigUserActions } from '@/store/models/dashboard-config.model';

import { useDashboardConfig } from '@/hooks/useDashboardConfig';

export const useAction = () => {
  const config = useDashboardConfig();

  const displayActionFromConfig = (action: TDashboardConfigUserActions): boolean =>
    !!config?.settings.users?.actions?.includes(action);

  return { displayActionFromConfig };
};
